import React from "react";
import { Dropdown } from "react-bootstrap";
import { MessageStatus } from "features/messages/enums/messageStatus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from './messageActionsMenu.module.scss';
import RolesChecker from "features/customer/components/RolesChecker";
import { useTranslation } from "react-i18next";

interface Props {
  messageId: string;
  messageStatus: MessageStatus;
  onMenuItemClick: (messageId: string, status: MessageStatus) => void;
}

const MessageActionsMenu = ({ messageId, messageStatus, onMenuItemClick }: Props) => {
  // translations
  const tTerms = useTranslation("shared\\terms").t;
  const tState = useTranslation("messages\\enums\\messageState").t;

  return (
    <Dropdown.Menu
      className={styles.menu}
    >
      <Dropdown.Item
        as="button"
        disabled={messageStatus === "Read"}
        className={styles.menuItem}
        onClick={() => onMenuItemClick(messageId, "Read")}
      >
        <div className="d-flex align-items-center">
          <span className={styles.itemIcon}>
            <FontAwesomeIcon icon="envelope-open" />
          </span>
          <span className={styles.itemText}>{tState(MessageStatus.Read)}</span>  
        </div>
      </Dropdown.Item>
      <Dropdown.Item
        as="button"
        disabled={messageStatus === "Unread"}
        className={styles.menuItem}
        onClick={() => onMenuItemClick(messageId, "Unread")}
      >
        <div className="d-flex align-items-center">
          <span className={styles.itemIcon}>
            <FontAwesomeIcon icon="envelope" />
          </span>
          <span className={styles.itemText}>{tState(MessageStatus.Unread)}</span>  
        </div>
      </Dropdown.Item>
      <RolesChecker enabledRoles="Contributor">
        <Dropdown.Divider />
        <Dropdown.Item
          as="button"
          className={styles.menuItem}
          onClick={() => onMenuItemClick(messageId, "Deleted")}
        >
          <div className="d-flex align-items-center text-danger">
            <span className="mr-3">
              <FontAwesomeIcon icon="trash" />
            </span>
            <span className={styles.itemText}>{tTerms("Delete")}</span>  
          </div>
        </Dropdown.Item>
      </RolesChecker>
    </Dropdown.Menu>
  );
};

export default MessageActionsMenu;
